<template>
  <div class="container">
    <van-nav-bar
      title="客户留资"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-icon class="pd12" @click="exportData" name="share-o" />
        <van-icon class="pd12" @click="onClickRight" name="search" size="18" />
      </template>
    </van-nav-bar>

    <div class="menu">
      <div class="menuitem">
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item title='联系结果' @change="searchList" v-model="isEnabled" :options="option1" />
          <van-dropdown-item title='客户意向' @change="searchList" v-model="isIntention" :options="option2" />
        </van-dropdown-menu>
      </div>
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
      @load="onLoad"
    >
      <div class="list-box">
        <div class="list clearfix" @click.stop="goDetail(item)" :key="index" v-for="(item,index) in projectList">
          <div class="mg10 flex">
            <div>{{item.updateTime}}</div>
            <div>
              <span :class="item.status == '已联系'?'col_b':'col_r'" >{{item.status}}</span>
            </div>
          </div>
          <div class="mg10 flex">
            <div>客户手机：{{item.mobile}}</div>
            <div class="sel_right">
              <img src="../assets/img/sel_right.png" alt="">
            </div>
          </div>
          <div class="flex">
            <div>客户姓名：{{item.name}}</div>
            <div v-if="item.status == '已联系'">
              <span :class="item.intentionDesc == '有意向'?'col_b':'col_r'" >{{item.intentionDesc}}</span>
            </div>
          </div>
          
        </div>
        
      </div>
    </van-list>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import { exportToExcel } from "@/Export2Excel";
  import {NavBar,Icon,Image,Toast,Loading,Search,Tabbar,TabbarItem,DropdownMenu, DropdownItem,List,Badge} from 'vant';
  export default {
    data() {
      return {
        active:1,
        keyword: '',
        startTime: '',
        endTime: '',
        isEnabled: '',//联系结果
        isIntention: '',//客户意向
        allCount:0,
        pageIndex:1,
        pageSize:10,
        loading: false,
        finished:false,
        projectList:[],
        option1: [
          { text: '全部', value: '' },
          { text: '未联系', value: false },
          { text: '已联系', value: true },
        ],
        option2: [
          { text: '全部', value: '' },
          { text: '无意向', value: false },
          { text: '有意向', value: true },
        ],
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Search.name]:Search,
      [Tabbar.name]:Tabbar,
      [TabbarItem.name]:TabbarItem,
      [DropdownMenu.name]:DropdownMenu,
      [DropdownItem.name]:DropdownItem,
      [List.name]:List,
      [Badge.name]:Badge,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      goDetail(item){
        this.$router.push({path: "khInfo.html",query:{rowId:item.id}})
      },
      onLoad(){
        // 异步更新数据
        setTimeout(()=>{
          this.pageIndex++;
          this.getMoreList();
        },500)
      },
      searchList(){
        this.pageIndex = 1;
        this.getProjectList();
      },
      getProjectList() {
        axios.post("/custominformation/pagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            startTime: this.startTime,
            endTime: this.endTime,
            isEnabled: this.isEnabled,
            isIntention: this.isIntention
          }
        }).then((res)=>{
          this.projectList = res.data.list;
          this.allCount = res.data.total;
        })
      },
      getMoreList() {
        axios.post("/custominformation/pagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            startTime: this.startTime,
            endTime: this.endTime,
            isEnabled: this.isEnabled,
            isIntention: this.isIntention
          }
        }).then((res)=>{
          this.projectList = this.projectList.concat(res.data.list);
          this.allCount = res.data.total;
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
        })
      },
      exportData() {
        //导出
        axios.post("/custominformation/alllist", {
          keyword: this.keyword,
          startTime: this.startTime,
          endTime: this.endTime,
          isEnabled: this.isEnabled,
          isIntention: this.isIntention,
        }).then((res) => {
          if(res.data.length == 0){
            Toast('暂无数据');
            return
          }else if(!res.isSuccess){
            Toast(res.message);
            return
          }
          if(res.data.length > 0){
            let exportList = {
              columns: {
                updateTime: "时间",
                name: "姓名",
                mobile: "手机号",
                status: "联系结果",
                intentionDesc: "客户意向",
              },
              exports: res.data,
            };
            exportToExcel(exportList, this.$route.name);
            Toast('导出成功');
          }
        })
      },
      onClickLeft() {
        this.$router.replace({path: 'home.html'})
      },
      onClickRight() {
        this.$router.push({path: "search.html",query:{pageType: 4}});
      },
    },
    computed:{
    },
    created () {
      this.keyword = this.$route.query.keyword;
      this.startTime = this.$route.query.startTime;
      this.endTime = this.$route.query.endTime;
      this.getProjectList();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less"> 
  @import "../assets/css/default.less";
  [v-cloak]{ 
    display:none !important;
  }
</style>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
    padding-bottom: 10px;
  }
  .list-box{
    width: 100%;
    color: #373737;
    .list{
      font-size: 14px;
      width: 100%;
      background: #fff;
      margin: 12px 0;
      padding: 12px;
      position: relative;
      .sel_right{
        img{
          width: 6px;
          margin-left: 8px;
          vertical-align: middle;
          margin-bottom: 3px;
        }
      }
    }
    .width80{width: 80%;}
    .mg10{margin-bottom: 10px;}
    .mg20{margin: 14px 0 25px 0;}
    .bold{font-weight: bold;}
  }

  .dot{
    width: 10px;
    height: 10px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 10px;
    text-align: center;
    background: #ee0a24;
  }
  .van-icon{
    font-size: 18px;
    color: #373737;
    vertical-align: bottom;
    padding: 0 0 2px 10px;
  }
  .pd12{
    padding: 13px 16px;
  }
  /deep/.van-nav-bar__title{font-weight: bold;}

</style>
